import React from 'react';
import { Pie } from '@ant-design/plots';
import { defaultColors } from '../helpersCharts';

export const Donut = ({ data, widthChart, heightChart, redirectToClicked }) => {

    const config = {
        legend: false,
        width: widthChart,
        height: heightChart,
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.7,
        color: defaultColors,
        marker: {
            style: {
                fontSize: 28
            }
        },
        label: {
            type: 'inner',
            offset: '-50%',
            content: '{value}',
            style: {
                textAlign: 'center',
                fontSize: 0,
            },
        },
        interactions: [
            /*  {
                 type: 'element-selected',
             }, */
            {
                type: 'element-active',
            },
        ],
        onReady: (plot) => {
            plot.on('element:click', (args) => {
                if (args.data) {
                    const { data } = args.data;
                    redirectToClicked(data);
                }
            });
        },
        statistic: {
            title: false,
            content: false
             /* {
                content: '',
            } */,
        },
    };
    return <Pie {...config} />;
};
